import { RootState } from 'types/global';

export const selectSearchValue = ({ search }: RootState) => search.searchValue;

export const selectIsSearchLoading = ({ search }: RootState) =>
  search.isLoading;
